import { observer } from 'mobx-react-lite'
import { CSSProperties, FC, useEffect } from 'react'
import styled from 'styled-components'
import { animationStore } from '@features/exercise/AIVideo/process'

interface CircleProps {
	left: number
	top: number
	type?: 'ref' | 'common'
	style?: CSSProperties
}

const SpinnerItem = styled.div<{ scale: number; opacity: number }>`
    border: 2px solid #c6c6c6;
    border-radius: 50%;
    height: 70px;
    width: 70px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(${({ scale }) => scale});
    opacity: ${({ opacity }) => opacity});
    box-shadow: 0 0 0 1px #000000;
`

const calculateScale = (value: number): number => {
	const min: number = 0.2
	const max: number = 1
	const range: number = max - min
	return ((((value - min) % range) + range) % range) + min
}

const calculateOpacity = (value: number): number => {
	const min: number = 0.2
	const max: number = 1
	const range: number = max - min
	return ((((value - min) % range) + range) % range) + min
}

export const Circle: FC<CircleProps> = observer(({ left, top, type = 'common', style }) => {
	const animationState = animationStore.animationState
	const scale: number = animationState.scale
	const opacity: number = animationState.opacity

	const scale1: number = calculateScale(scale + 0.26)
	const scale2: number = calculateScale(scale1 + 0.26)

	const opacity1: number = calculateOpacity(opacity - 0.26)
	const opacity2: number = calculateOpacity(opacity1 - 0.26)

	useEffect(() => {
		animationStore.startAnimation()

		return () => {
			animationStore.stopAnimation()
		}
	}, [])

	return (
		<div
			style={{
				position: 'absolute',
				left: type === 'common' ? left - 5 : left,
				top: type === 'common' ? top - 5 : top,
				...style,
			}}>
			{type === 'common' ? (
				<div style={{ width: 10, height: 10, background: 'white', borderRadius: 20 }}></div>
			) : (
				<>
					<SpinnerItem scale={scale} opacity={opacity} />
					<SpinnerItem scale={scale1} opacity={opacity1} />
					<SpinnerItem scale={scale2} opacity={opacity2} />
				</>
			)}
		</div>
	)
})
